import { createFileRoute, Link, useLocation } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { Trans, useTranslation } from 'react-i18next';

import { useAuthEmail } from '@/components/auth/shared/auth-email';
import { AuthCard } from '@/components/auth/shell/auth-card';
import { AuthSplitShell } from '@/components/auth/shell/auth-split-shell';
import { AuthTopLink } from '@/components/auth/shell/auth-top-link';
import { VerifyEmailForm } from '@/components/auth/verify-email/verify-email-form';
import { ROUTES } from '@/constants/routes';
import { meQueryOptions } from '@/hooks/data/use-auth';
import { loadNamespaces } from '@/lib/i18n/i18n';
import { AUTH_HEADLINE } from '@/components/ui/typography';

export const Route = createFileRoute('/_public/verify-email')({
  loader: () => loadNamespaces('auth'),
  staticData: { title: 'route.verify_email.title' },
  component: VerifyEmailPage,
});

const TopBar = () => {
  const { t } = useTranslation('auth');

  return (
    <AuthTopLink to={ROUTES.SIGNUP}>{t('verify_email.top_back')}</AuthTopLink>
  );
};

interface LocationStateWithPassword {
  password?: string;
}

function VerifyEmailPage() {
  const { t } = useTranslation('auth');
  const location = useLocation();
  const { data: user } = useQuery(meQueryOptions);

  const email = useAuthEmail(user?.email) ?? '';
  const state = location.state as LocationStateWithPassword | undefined;
  const password = state?.password ?? null;

  return (
    <AuthSplitShell topBar={<TopBar />}>
      <h1 className={AUTH_HEADLINE}>{t('verify_email.heading')}</h1>

      <AuthCard>
        {email ? (
          <VerifyEmailForm email={email} password={password} />
        ) : (
          <p className="text-fg-3 text-fs-13 text-center">
            <Trans
              i18nKey="verify_email.missing_email"
              ns="auth"
              components={{
                a: (
                  <Link
                    to={ROUTES.SIGNUP}
                    className="text-fg-1 font-semibold underline-offset-4 hover:underline"
                  />
                ),
              }}
            />
          </p>
        )}
      </AuthCard>
    </AuthSplitShell>
  );
}
